import stringify from "jsonld-stable-stringify"

export default class Microdata {
  data = []
  pageData
  url

  constructor(url, page) {
    this.url = url
    this.pageData = page

    if (!this.url) {
      throw new Error("An URL is required.")
    }

    return this
  }

  page() {
    const data = {
      "@context": "https://schema.org",
      "@type": this.pageData.types ?? ["WebPage"],
      /* datePublished: this.item.date,
      dateModified: this.item.date, */
    }

    if (this.pageData.image) {
      data.image = this.pageData.image
    }

    this.data.push(data)

    return this
  }

  setMainEntity(data) {
    this.data[0].mainEntity = data

    return this
  }

  get() {
    const graph = {
      "@graph": this.data,
    }

    return stringify(graph)
  }
}
